
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDGYiXvGmeceWzehEi5hiC6NhiLOqRc7Do'
export const GOOGLE_MAPS_API_CHANNEL = 'tol-admin'

export const STATES_CODES = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN',
  'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MH', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM',
  'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'PW', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA',
  'WI', 'WV', 'WY']

export const SISENSE_DASHBOARD_BASE = '//bi.us-east-1.public.rnv3eiup9x8f.grsthrive.com/app/main#/dashboards/'
